export type Review = {
  id: number;
  userId: number;
  title: string;
  text: string;
  featured: boolean;
  rating: number;
  date: Date;
  practiceId: number;
  userName: string;
  isRead: boolean;
  isNameShown: boolean;
  userEmail: string;
  reply: null;
  source: null;
  replyDate: null;
  publicProfileUrl: null;
  practiceMicrositeUrl: string | null;
  socialMedia: SocialMedia;
  patientReviewUrl?: string;
};

export type SocialMedia = {
  googleTemplateId: number;
  yelpTemplateId: number;
  practiceGoogleReviewUrl: null;
  practiceYelpReviewUrl: null;
  isFacebookProfileConnected: boolean;
  facebookAppId: null;
  facebookPermissionScopes: string;
  isTwitterProfileConnected: boolean;
};

export type Survey = {
  id: number;
  userId: number;
  userName: string;
  score: number;
  date: Date;
  isRecommended: boolean;
  note: string;
  questions: Question[];
  suveyStatistics: null;
  isRead: boolean;
};

export type Question = {
  text: string;
  score: number;
  sequenceNumber: number;
};

export interface PatientFeedback {
  idPatientFeedback: number;
  date: Date;
  message: string;
  ratingScore: number;
  feedbackType: FeedbackType;
}

export enum FeedbackType {
  Review = 1,
  Survey = 2
}
